"use client";

import LoaderSkeleton from "component/loader-skeleton/LoaderSkeleton";
import withSession from "hoc/withSession";
import { RootState } from "interfaces/generics.type";
import { useSelector } from "react-redux";
import AccountOverview from "../AccountOverview";
import AccountOverviewNotSignedIn from "../AccountOverviewSignIn";

function AccountOverviewWrapper() {
  const { loggedIn } = useSelector((state: RootState) => state.authenticationState);

  if (loggedIn) {
    return <AccountOverview />;
  }

  return <AccountOverviewNotSignedIn />;
}

function SkeletonLoader() {
  return (
    <LoaderSkeleton height={60} />
  );
}

export default withSession(AccountOverviewWrapper, SkeletonLoader);
